<template>
  <!-- numeração -->
  <div class="md:col-span-3">
    <BaseInput
      type="text"
      name="itensForm.value.numeracao"
      v-model="store.itensForm.values.numeracao"
      :info="'Numeração e etiqueta'"
      label="Numeração e etiqueta"
      :required-field="false"
      :activeDefault="false"
    >
      <template #append>
        <CleanInputButton @click="store.itensForm.values.numeracao = undefined" />
      </template>
    </BaseInput>
  </div>

  <!-- estado da caixa -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Estado da caixa
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.estado_caixa"
          :initialValue="store.itensForm.values.estado_caixa"
          @selected-data="(val) => (store.itensForm.values.estado_caixa = val)"
        />
      </div>
    </div>
  </div>

  <!-- qtd mangueiras -->
  <div class="md:col-span-1">
    <BaseInput
      type="number"
      :min="1"
      name="itensForm.values.qtd_mangueira"
      v-model="store.itensForm.values.qtd_mangueira"
      :info="'Qtd. Mangueiras'"
      label="Qtd. Mangueiras"
      :required-field="false"
      :activeDefault="false"
    >
      <template #append>
        <CleanInputButton @click="store.itensForm.values.qtd_mangueira = undefined" />
      </template>
    </BaseInput>
  </div>

  <!-- estado das mangueiras -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Estado das mangueiras
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.estado_caixa"
          :initialValue="store.itensForm.values.estado_mangueiras"
          @selected-data="(val) => (store.itensForm.values.estado_mangueiras = val)"
        />
      </div>
    </div>
  </div>

  <!-- bicos e chaves -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Bicos e chaves
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.bicos_e_keys"
          :initialValue="store.itensForm.values.bicos_e_keys"
          @selected-data="(val) => (store.itensForm.values.bicos_e_keys = val)"
        />
      </div>
    </div>
  </div>

  <!-- sinalização -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Sinalização
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.sinalizacao"
          :initialValue="store.itensForm.values.sinalizacao"
          @selected-data="(val) => (store.itensForm.values.sinalizacao = val)"
        />
      </div>
    </div>
  </div>

   <!-- pintura do hidrante -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Pintura do hidrante
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.pintura_abrigo"
          :initialValue="store.itensForm.values.pintura_hydrante"
          @selected-data="(val) => (store.itensForm.values.pintura_hydrante = val)"
        />
      </div>
    </div>
  </div>

  <!-- pintura do abrigo -->
  <div class="md:col-span-1">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Pintura do abrigo
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.pintura_abrigo"
          :initialValue="store.itensForm.values.pintura_abrigo"
          @selected-data="(val) => (store.itensForm.values.pintura_abrigo = val)"
        />
      </div>
    </div>
  </div>

</template>

<script setup>
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import CleanInputButton from '../../../utils/CleanInputButton.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import { dataExtinguisher } from '../../../store'
import { hydrant } from '../../../lookups/form'

const store = dataExtinguisher.state

</script>
